import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import { CombinedImage } from '@ynap/image';

const bem = new BEMHelper('StickyContainer');

interface Image {
    id: string;
    url: string;
    alt: string;
    srcSet: string;
}

interface StickyContainerProps {
    image: Image;
    /* eslint-disable no-unused-vars */
    setIsZoomModalVisible: (visible: boolean) => void;
    setSelectedZoomImageIndex: (index: number) => void;
}

const StickyContainer = ({ image, setIsZoomModalVisible, setSelectedZoomImageIndex }: StickyContainerProps) => {
    return (
        <div>
            <div className={bem('stickyWrapper')}>
                <div
                    onClick={() => {
                        setIsZoomModalVisible(true);
                        setSelectedZoomImageIndex(0);
                    }}
                    className={bem('imageContainer')}
                >
                    <CombinedImage
                        key={image.id}
                        src={image.url}
                        alt={image.alt}
                        primarySrcset={image.srcSet}
                        displaySrc
                        yOffset="100%"
                        withIntersectionObserver={false} //remove intersection observer for first image
                        cover
                    />
                </div>
            </div>
        </div>
    );
};

export default StickyContainer;
